import script from "./FieldConfigPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldConfigPanel.vue?vue&type=script&setup=true&lang=js"

import "./FieldConfigPanel.vue?vue&type=style&index=0&id=8c7b5060&scoped=true&lang=css"

import exportComponent from "/Users/dioratar/Documents/_project/omni/repo/emetrai/event-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c7b5060"]])

export default __exports__